import { Card } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import TableMedias from "@/modules/relatorio/components/table-medias";
import { TRelatorioContext } from "../RelatorioLayout";

const MediasTab = () => {
  const { empresasComMedia, loadingMedias, errorMedias } = useOutletContext<TRelatorioContext>();

  return (
    <Card>
      <TableMedias empresasComMedia={empresasComMedia} loading={loadingMedias} error={errorMedias} />
    </Card>
  );
};

export default MediasTab;
